<div class="headerWithRightButton">
    <div class="header-label">{{headerlabel}}</div>
    <div class="button-section" *ngIf="showBtn">
        <acengage-button [isNgContentAdded]="true" (buttonClicked)="buttonClicked($event)" [buttonText]="buttonlabel">
            <ng-content></ng-content>
        </acengage-button>
    </div>
</div>
